import {
  DirectPatientRequest,
  PendingAppointment,
  PendingPatientActivationRequest,
  PendingPatientQueryParams,
  PendingPatientRequest
} from './pendingPatient.model';
import {
  ID,
  ListApiResponse,
  SingleApiResponse,
  SuccessApiResponse,
  unwrapApiErrorDetails
} from '@ianesthesie-kit/services';
import axios from 'axios';
import { WithPagination } from '@/hooks';
import { stringify } from 'query-string';
import { Patient } from '@/modules/surgicalEvent';

export class PendingPatientService {
  private static readonly URL = '/bff/doctor/pending-appointment';

  public static fetchPendingAppointments(
    queryParams?: WithPagination<PendingPatientQueryParams>
  ): Promise<ListApiResponse<PendingAppointment>> {
    // const qs = toKebabQuery(queryParams, false); // TODO use kebab case when backend ready
    const qs = stringify(queryParams ?? {});
    let url = this.URL;
    if (queryParams?.query) {
      url += '/search';
    }
    url += `?${qs}`;
    return axios
      .get<ListApiResponse<PendingAppointment>>(url)
      .then((resp) => resp.data)
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }

  public static createDirectPatient(
    payload: DirectPatientRequest
  ): Promise<SingleApiResponse<Patient>> {
    return axios
      .post<SingleApiResponse<Patient>>('/bff/doctor/patient', payload)
      .then((resp) => resp.data)
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }

  public static createPendingPatient(
    payload: PendingPatientRequest
  ): Promise<SuccessApiResponse> {
    return axios
      .post<SuccessApiResponse>(this.URL, payload)
      .then((resp) => resp.data)
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }

  public static activatePendingPatient(
    payload: PendingPatientActivationRequest
  ): Promise<SingleApiResponse<Patient>> {
    return axios
      .post<SingleApiResponse<Patient>>(`${this.URL}/activation`, payload)
      .then((resp) => resp.data)
      .catch((err) => {
        const details = unwrapApiErrorDetails(err);
        if (details?.businessCode === 'E1-1-2-1012') {
          // already activated
          details.businessCode += '_dd'; // doctor-dashboard-specific variation of app.error.E1-1-2-1012
        }
        throw details || err;
      });
  }

  public static deletePendingAppointment(id: ID): Promise<SuccessApiResponse> {
    return axios
      .delete<SuccessApiResponse>(`${this.URL}/${id}`)
      .then((resp) => resp.data)
      .catch((err) => {
        throw unwrapApiErrorDetails(err) || err;
      });
  }
}
